module.exports = __webpack_public_path__ + "static/media/get-scholorship1.bc192ba7.jpg";